exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ms */\n.cheetah-grid__inline-input::-ms-clear {\n\tvisibility: hidden;\n}\n.cheetah-grid__inline-input {\n\tposition: absolute;\n\tbox-sizing: border-box;\n}\n", ""]);

// exports
